module.exports = __webpack_public_path__ + "img/success.75accc6b.gif";